import React from "react";
import { ArrowLeft, BarChart3, CalendarDays, ClipboardCheck, Clock3, Download, Gauge, Settings2, Trophy } from "lucide-react";

const VIEWS = [
  ["overview", "Overview", Gauge],
  ["daily-entry", "Daily Entry", ClipboardCheck],
  ["daily-history", "Daily History", Clock3],
  ["monthly", "Monthly", CalendarDays],
  ["quarterly", "Quarterly", BarChart3],
  ["leaderboard", "Leaderboard", Trophy],
  ["reports", "Reports", Download],
  ["config", "Configuration", Settings2]
];

export default function KpiPageHeader({ title, subtitle, icon: Icon = Gauge, onBack, backLabel = "Home", activeView, onNavigate, allowedViews, children }) {
  return <>
    <header className="kpi-module-header">
      <div className="kpi-module-identity">
        <button className="kpi-home-button" type="button" onClick={onBack} aria-label={`Back to ${backLabel}`}>
          <ArrowLeft size={18} aria-hidden="true" /> {backLabel}
        </button>
        <div className="kpi-page-heading">
          <span className="operations-eyebrow">Sales Floor / KPI</span>
          <h1><Icon size={28} aria-hidden="true" /> {title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      {children && <div className="kpi-header-controls">{children}</div>}
    </header>
    {onNavigate && <nav className="kpi-module-nav" aria-label="KPI modules">
      {VIEWS.filter(([id]) => !allowedViews || allowedViews.includes(id)).map(([id, label, ViewIcon]) => <button
        key={id} className="kpi-nav-item" type="button"
        aria-current={activeView === id ? "page" : undefined}
        onClick={() => onNavigate(id)}
      ><ViewIcon size={18} aria-hidden="true" /> {label}</button>)}
    </nav>}
  </>;
}
